import { COUNTRY_BY_CODE } from 'lib/datasets/countries';
import { ILocation } from 'lib/types/user';
import _ from 'lodash';
import { PopulationRuleType } from './types';

export const getRuleLabelName = (ruleType: PopulationRuleType): string =>
  _.chain(ruleType).lowerCase().startCase().value();

export const isLocationUsa = (location: ILocation): boolean =>
  location.country === COUNTRY_BY_CODE.USA.code;
